export function tw(string: TemplateStringsArray) {
	return string;
}

export const isMobile = window.innerWidth <= 1280;

export const totalGoalMarkets: { [x: string]: { name: string; displayName: string } } = {
	["[Total Goals] 0.5"]: { name: "[Total Goals] 0.5", displayName: "0.5" },
	["[Total Goals] 1.5"]: { name: "[Total Goals] 1.5", displayName: "1.5" },
	["[Total Goals] 2.5"]: { name: "[Total Goals] 2.5", displayName: "2.5" },
	["[Total Goals] 3.5"]: { name: "[Total Goals] 3.5", displayName: "3.5" },
	["[Total Goals] 4.5"]: { name: "[Total Goals] 4.5", displayName: "4.5" },
	["[Total Goals] 5.5"]: { name: "[Total Goals] 5.5", displayName: "5.5" },
};

export const disableRestrikeErrors = [6900016, 100010];

export const mediaLibrariesPath = "medialibraries/content.gmgamingsystems.com/Synapse/v2";
